import React from "react";
import PositionChangeIndicator from "./PositionChangeIndicator.jsx";
import { Link } from "react-router-dom";
import { FormattedMoneyHideZero } from "../utils/FormattedMoneyHideZero";
import HighlightableText from "../Common/HighlightableText";

let renderPlayerRankIcon = function (entry) {
  if (entry["playerRankNameByRegulation"]) {
    return (
      <span>
        <i
          title={entry["playerRankNameByRegulation"]}
          className={`icon-player-rank icon-player-rank--${entry["playerRankIconTypeByRegulation"]}`}
        />
        <i
          title={entry["playerRankNameByLevel"]}
          className={`icon-player-rank icon-player-rank--${entry["playerRankIconTypeByLevel"]}`}
        />
      </span>
    );
  }
  return null;
};
let participatesInSubleagueStar = function (entry) {
  if (entry.countsToSubleague) {
    return (
      <span className="ranking-entry__star">
        <span className="glyphicon glyphicon-star" />
      </span>
    );
  }
  return null;
};

const RankingCell = ({
  entry,
  column,
  onDetailsClick,
  ticketImg,
  game,
  marked,
}) => {
  switch (column.type) {
    case "position": {
      let positionDiff = 0;
      let positionPrevious = null;

      // so we have two cases for subleagues subleague details we don't have the positionPrevious
      // instead we added a new key called positionOld
      // so if there is no positionPrevious we see if it has the positionOld
      // if none of them available we show 0
      if(entry.hasOwnProperty("positionPrevious")){
        positionDiff = entry.positionPrevious ? entry.positionPrevious - entry.position : 0;
        positionPrevious = entry.positionPrevious;

      }else if(entry.hasOwnProperty("positionOld")){
        positionDiff = entry.positionOld ? entry.positionOld - entry.position : 0;
        positionPrevious = entry.positionOld;
      }else {
        positionDiff = 0;
        positionPrevious = null;
      }

      return (
        <td className="ranking-entry__position">
          <PositionChangeIndicator
            className="ranking-entry__diff-icon"
            difference={positionDiff}
          />
          <strong>{entry.position}</strong>
          {positionDiff ? ` (${positionPrevious?positionPrevious: ''})` : null}
        </td>
      );
    }

    case "teamName":
      return (
        <td>
          <span className="ranking-entry__team-name-wrap">
            <Link to={`/results/${game.id}/team/${entry.zweelerTeamId}`}
              className={"ranking-entry__team-name"}
            >
              <HighlightableText active={marked}>
                {entry.teamName}
              </HighlightableText>
            </Link>
          <span className="mobile-display-hover">{` | ${entry.userName}`}
              {participatesInSubleagueStar(entry)}
              {' '}
              {renderPlayerRankIcon(entry)}
          </span>
          </span>
        </td>
      );

    case "pointsTotal":
      return (
        <td className="ranking-entry__points-total-wrap">
          <span className="ranking-entry__points-total">
            {" "}
            {`${entry.pointsTotal}`}
          </span>
          {entry.pointsNew ? (
            <button
              onClick={onDetailsClick}
              className="ranking-entry__points-new"
            >
              {` (${entry.pointsNew > 0 ? "+" : ""}${entry.pointsNew})`}
            </button>
          ) : null}
        </td>
      );

    case "pointsWithPreviousLinked":
      return (
        <td className="ranking-entry__points-total-wrap">
          <button className="ranking-entry__points" onClick={onDetailsClick}>
            <span className="ranking-entry__points-total">
              {" "}
              {`${entry.pointsTotal}`}
            </span>
            <span className="ranking-entry__points-new">
              {` (${entry.pointsNew > 0 ? "+" : ""}${entry.pointsNew || "+0"})`}
            </span>
          </button>
        </td>
      );

    case "pointsLinked":
      return (
        <td>
          <button className="ranking-entry__points" onClick={onDetailsClick}>
            {`${entry.pointsTotal} `}
          </button>
        </td>
      );

    case "pointsTotalBold":
      return (
        <td>
          <button
            onClick={onDetailsClick}
            className="ranking-entry__points-total ranking-entry__points-total--clickable"
          >
            <strong>{entry.pointsTotal}</strong>
          </button>
        </td>
      );

    case "money":
      if (entry.ticketWon) {
        return (
          <td>
            <img src={`/main/images/tickets/${ticketImg}mini1.png`} />
          </td>
        );
      }
      if (entry.qualificationPlayoffs) {
        return (
          <td>
            <img src={`/main/images/tickets/${ticketImg}_playoff_mini.png`} />
          </td>
        );
      }
      if (entry.money) {
        return (
          <td>
            <FormattedMoneyHideZero {...entry.money} />
          </td>
        );
      }
      return <td />;

    case "jackpot":
      return (
        <td
          className={`ranking-entry__jackpot--${
            entry.jackpotWon ? "success" : "fail"
          }`}
        >
          {`${entry.predictionsCorrect}/${entry.predictionsTotal}`}
        </td>
      );

    default:
      return <td>{entry[column.key]}</td>;
  }
};

export default RankingCell;
